type RefreshRedirectWindow = Pick<Window, 'history' | 'location' | 'performance'>;

type LegacyPerformanceNavigation = {
  type?: number;
  TYPE_RELOAD?: number;
};

type PerformanceWithLegacyNavigation = Performance & {
  navigation?: LegacyPerformanceNavigation;
};

export const normalizeRefreshPathname = (pathname: string): string => {
  const trimmedPathname = pathname.trim();
  if (!trimmedPathname || trimmedPathname === '/') {
    return '/';
  }

  return trimmedPathname.replace(/\/+$/, '') || '/';
};

export const shouldRedirectRefreshPathToDashboard = (_pathname: string): boolean => {
  // ADR-121: preserve the exact route on refresh so paid object continuity works.
  // The old bootstrap collapsed protected paths to /dashboard, which broke token
  // dossier and signal return targets after private pass activation.
  return false;
};

export const isBrowserReload = (win: Pick<Window, 'performance'> = window): boolean => {
  const navigationEntries = win.performance.getEntriesByType?.('navigation') ?? [];
  const navigationEntry = navigationEntries[0] as PerformanceNavigationTiming | undefined;

  if (navigationEntry?.type) {
    return navigationEntry.type === 'reload';
  }

  const legacyNavigation = (win.performance as PerformanceWithLegacyNavigation).navigation;
  const legacyReloadType = legacyNavigation?.TYPE_RELOAD ?? 1;

  return legacyNavigation?.type === legacyReloadType;
};

export const redirectRefreshToDashboard = (win: RefreshRedirectWindow = window): boolean => {
  if (!isBrowserReload(win) || !shouldRedirectRefreshPathToDashboard(win.location.pathname)) {
    return false;
  }

  return true;
};
